module.exports = __webpack_public_path__ + "img/keen-v-2021.116bad06.jpg";